/**
 * chapter-metadata-patch — 章节元数据编辑「只发真正改动的字段」补丁构造（编辑器保存用）
 *
 * Why：元数据 PATCH 无版本锁，全量重发会让两个运营并发改同一章不同字段时后保存者用自己加载时的
 * 旧值覆盖另一人的改动（last-write-win）。只发真正变化的字段，把覆盖面收敛到「确实改了的字段」。
 *
 * dev-docs `02-API契约/A6-书籍域.md` §9.4 起本端点可改字段只剩 `title`：`cost` / `is_free` 是
 * `03-数据字典/20-内容.md` §3.0 的纯派生列、不接受入参（误传 `VALIDATION_FAILED`）。
 */

import type { PatchChapterMetadataRequest } from '@novel-admin/shared';

/** 元数据编辑可见字段快照（调用方传归一后值：title 已 trim）。 */
export interface ChapterMetadataSnapshot {
  title: string;
}

/**
 * 算只含改动字段的元数据补丁。`base` = 章节加载时基线，`next` = 当前编辑值。
 *
 * 返回空对象 = 无服务端可见变化 → 调用方应跳过 PATCH（server 拒空 body）。
 */
export function buildChapterMetadataPatch(
  base: ChapterMetadataSnapshot,
  next: ChapterMetadataSnapshot,
): PatchChapterMetadataRequest {
  const patch: PatchChapterMetadataRequest = {};
  if (next.title !== base.title) patch.title = next.title;
  return patch;
}
